export default "__VITE_ASSET__8TsYD6nc__"